import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Invoice } from '../../../models/invoices/invoice';
import { UIHelpers } from '../../../core/ui-helpers';
import { InvoiceService } from '../../../models/invoices/invoiceService';
import { InvoiceSettings } from '../../../models/invoices/invoiceSettings';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'invoice-preview-dialog',
  templateUrl: './invoice-preview.component.html',
  standalone: false,
})
export class InvoicePreviewComponent {
  public invoice: Invoice = Invoice.createEmpty();
  public currentDate: string = new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  public dueDate: string = '';
  public merchantName: string = '';
  public merchantEmail: string = '';
  public merchantPhone: string = '';
  public customerName: string = '';
  public customerEmail: string = '';
  public customerPhone: string = '';
  public subTotal: number = 0;
  public tax: number = 0;
  public customMessage: string = '';
  public invoiceUrl: string = '';

  constructor(
    public dialogRef: MatDialogRef<InvoicePreviewComponent>,
    public uiHelpers: UIHelpers,
    public invoiceService: InvoiceService,
  ) {}

  ngOnInit() {
    this.invoiceService
      .getInvoiceSettings(this.invoice.merchantId)
      .then((invoiceSettings: InvoiceSettings) => {
        this.customMessage = invoiceSettings.initialNotification;
      });
    this.invoiceUrl = `${environment.portalUrl}/payable-invoice?id=${this.invoice.id}`;
  }

  handleSendClicked() {
    this.dialogRef.close('send');
  }

  handleCancelClicked() {
    this.dialogRef.close('cancel');
  }
}
